import api from ".";

export const getPayments = (params) => api.get("/payments", { params });

export const getPaymentDetails = (paymentId) => api.get(`/payments/${paymentId}`);

export const initiatePayment = (data) => api.post("/payments/initiate-payment", data);

export const verifyPayment = (data) => api.post("/payments/verify-payment", data);
